import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/reducers';
import { PaginationRequest } from 'src/app/models/common/paginationRequest';
import { AppSessionService } from '../app-session/app-session.service';

@Injectable({
  providedIn: 'root'
})
export class CountriesService {

  private BASE_URL = this.appSession.baseUrl + '/api/v1/countries';

  constructor(private http: HttpClient, private store: Store<AppState>, private appSession: AppSessionService) { }

  getCountries(pageReq: PaginationRequest): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/x-www-form-urlencoded; ');

    if (pageReq && pageReq.query && (<string>pageReq.query).length > 0) {
      headers = headers.set('query', pageReq.query);
    }

    let url = `${this.appSession.baseUrl + '/api/v1/countries'}`;

    if (!pageReq) {
      // pageReq not defined
      pageReq = {
        offset: 0,
        limit: 200,
        realSize: false
      }
    }
    let sort: string = '';

    const pagination = '?offset=' + pageReq.offset + '&limit=' + pageReq.limit + '&real_size=' + pageReq.realSize;
    url = url.concat(pagination);
    return this.http.get(url, { headers });
  }

  getCountriesTranslated(pageReq: PaginationRequest): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/x-www-form-urlencoded; ');

    if (pageReq && pageReq.query && (<string>pageReq.query).length > 0) {
      headers = headers.set('query', pageReq.query);
    }

    let url = `${this.appSession.baseUrl + '/api/v1/countries'}/translated`;

    if (!pageReq) {
      // pageReq not defined
      pageReq = {
        offset: 0,
        limit: 40,
        realSize: false
      }
    }
    let sort: string = '';

    const pagination = '?offset=' + pageReq.offset + '&limit=' + pageReq.limit + '&real_size=' + pageReq.realSize;
    url = url.concat(pagination);
    return this.http.get(url, { headers });
  }

}
